export default __webpack_public_path__ + "static/media/background.009d110c.svg";